import * as React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '../../../../../../common/types/redux';
import { selectDetailsVisiblePrecision, selectMapBounds } from '../../../../../selectors';
import { TMapBounds } from '../../../../../types/mapBounds';
import { useFeaturesContext } from '../context';

interface IDetailsVisibilityManagerProps {
  onVisibilityChange(isVisible: boolean): void;
}

export const DetailsVisibilityManager: React.FC<IDetailsVisibilityManagerProps> = ({ onVisibilityChange }) => {
  const { pointsLayer, hotspotsLayer } = useFeaturesContext();
  const detailsVisiblePrecision = useSelector(selectDetailsVisiblePrecision);
  const { precision } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);

  const isDetailsVisibleByPrecision = precision >= detailsVisiblePrecision;

  React.useEffect(() => {
    const isDetailsVisible = isDetailsVisibleByPrecision;

    pointsLayer.layer.update();
    hotspotsLayer.isDetailsVisible = isDetailsVisible;
    hotspotsLayer.layer.update();

    onVisibilityChange(isDetailsVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDetailsVisibleByPrecision]);

  return null;
};
